// src/services/authService.js
import apiClient from '../api/apiClient';

const login = (email, password) => {
  return apiClient.post('/auth/login.php', { email, password });
};

const logout = () => {
  // If your PHP logout endpoint does server-side token invalidation (e.g., for opaque tokens)
  // return apiClient.post('/auth/logout.php');
  // For simple JWTs where logout is client-side (removing token), this might not be needed
  // or can just be a placeholder if you add server-side invalidation later.
  return Promise.resolve(); // Placeholder for now
};

// If you implement a /auth/me or /profile endpoint on the backend:
// const fetchUserProfile = () => {
//   return apiClient.get('/auth/me'); // Or your profile endpoint
// };

const authService = {
  login,
  logout,
  // fetchUserProfile,
};

export default authService;